export const webhookEventNames = [
  'client.created',
  'client.deleted',
  'client.updated',
  'client.customFields.updated',
  'client.activated',
  'company.created',
  'company.updated',
  'company.deleted',
  'form_response.completed',
  'file.created',
  'folder.created',
  'link.created',
  'message.sent',
  'contract.signed',
];
